import angular from 'angular'

import extractRawElm from '../utils/extract-raw-elm'

angular
  .module('ggs')
  .directive('a', SafeLinkDirective)
  .directive('iframe', DeTabIframeDirective)

const REL_NAME = 'rel'
const REL_VAL = 'noopener noreferrer'

const TARGET_NAME = 'target'
const TARGET_VAL = '_blank'

const TABINDEX_NAME = 'tabindex'
const TABINDEX_VAL = '-1'

function SafeLinkDirective() {
  return {
    restrict: 'E',
    link(_$scope, $elm) {
      const elm = extractRawElm($elm)

      if (elm.getAttribute(REL_NAME) === REL_VAL) {
        console.warn(`SafeLink: "${REL_NAME}" attribute already contains "${REL_VAL}" value!`, elm)
      } else {
        elm.setAttribute(REL_NAME, REL_VAL)
      }

      if (elm.getAttribute(TARGET_NAME) === TARGET_VAL) {
        console.warn(`SafeLink: "${TARGET_NAME}" attribute already contains "${TARGET_VAL}" value!`, elm)
      } else {
        elm.setAttribute(TARGET_NAME, TARGET_VAL)
      }

      if (elm.getAttribute(TABINDEX_NAME) === TABINDEX_VAL) {
        console.warn(`SafeLink: "${TABINDEX_NAME}" attribute already contains "${TABINDEX_VAL}" value!`, elm)
      } else {
        elm.setAttribute(TABINDEX_NAME, TABINDEX_VAL)
      }
    }
  }
}

function DeTabIframeDirective() {
  return {
    restrict: 'E',
    link(_$scope, $elm) {
      const elm = extractRawElm($elm)
      if (elm.getAttribute(TABINDEX_NAME) === TABINDEX_VAL) {
        console.warn(`DeTabIframe: "${TABINDEX_NAME}" attribute already contains "${TABINDEX_VAL}" value!`, elm)
      } else {
        elm.setAttribute(TABINDEX_NAME, TABINDEX_VAL)
      }
    }
  }
}
